import React, { Component } from 'react';
import { Col, Button, FormGroup } from 'reactstrap';
//eslint-disable-next-line
import { resourceData } from '../../../Resources/EULA/EULA.en-US'


export default class LoginLicenseTerms extends Component {

    componentWillMount() {
        import('../../../Resources/EULA/EULA.en-US').then((resourceData) => {
            this.setState({
                license_content: resourceData.resourceData
            });
        });
    }

    constructor(props) {
        super(props);
        this.state = {
            license_content: null
        }
    }

    language(event) {
        let data = null;
        data = event.target.value
        import('../../../Resources/EULA/EULA.' + data).then((resourceData) => {
            this.setState({
                license_content: resourceData.resourceData
            });

        });
    }



    render() {
        var CloseModal = this.props.CloseModal;
        let { license_content } = this.state
        let license_content_data = license_content;

        return (
            <div className="license_Modal">
                <div className="license_Modal_content_box">
                    <div className="license_header">
                        <h2 className="license_header_name">TERMS AND CONDITIONS - Licensed Material and Hosted Services</h2>
                        <select className="languages_select" onChange={event => { this.language(event) }}>
                            <option selected="selected" value="en-US">English (United States)</option>
                            {/* <option value="es-MX">español (México)</option>
                            <option value="id-ID">Bahasa Indonesia (Indonesia)</option>
                            <option value="ja-JP">日本語 (日本)</option>
                            <option value="ko-KR">한국어(대한민국)</option>
                            <option value="pt-BR">português (Brasil)</option>
                            <option value="th-TH">ไทย (ไทย)</option> */}
                        </select>
                    </div>

                    <div>
                        <textarea className="license_Content" value={license_content_data} ></textarea>
                    </div>
                    <div className="">
                        <FormGroup row >
                            <Col sm={{ size: 12 }}>
                                <Button className="btn-black btn-md ChangeLimits_Applybtn" onClick={() => CloseModal('Cancel')}>Close</Button>
                            </Col>
                        </FormGroup>
                    </div>
                </div>

            </div>
        );
    }
}



